export default "﻿<h1>PhoneInput</h1>\n<a href=\"https://github.com/jackocnr/intl-tel-input\" target=\"_blank\">Dokumentation</a>"